import React from 'react';
import { IconButton } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withRouter } from 'react-router-dom';
// import styled from 'styled-components/macro';

// const StyledIconButton = styled(IconButton)`
//   && {
//     border: 1px solid #4c84ff;
//   }
// `;

const BackButton = ({ history, onClick = history.goBack, ...props }) => {
  const isIE = /*@cc_on!@*/ false || !!document.documentMode;
  return (
    !isIE && (
      <IconButton color="primary" onClick={onClick} {...props}>
        <ArrowBackIcon />
      </IconButton>
    )
  );
};

export default withRouter(BackButton);
